import { PayloadAction } from '@reduxjs/toolkit';
import { MemoryState } from '../state';

export const fetch = (state: MemoryState, action: PayloadAction) => {

}
